import { render, staticRenderFns } from "./ContactFormSection.vue?vue&type=template&id=10893b12&scoped=true&"
import script from "./ContactFormSection.vue?vue&type=script&lang=js&"
export * from "./ContactFormSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormSection.vue?vue&type=style&index=0&id=10893b12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10893b12",
  null
  
)

export default component.exports